import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import SpecialCard from '@pages/Alarmas_EditCreate/components/SpecialCard';
import TagCondition from '@pages/Alarmas_EditCreate/components/TagCondition';

import SimpleCondition from '../SimpleCondition';
import useGroupCondition from './useGroupCondition';
import styles from './GroupCondition.module.less';

function GroupCondition(props) {

  const { t } = useTranslation();
  const { index } = props;
  const {
    orConditions, addOrCondition, removeGroupCondition, isEditDefault,
  } = useGroupCondition({
    index,
  });

  return (
    <SpecialCard>
      <div className={styles.top_elements}>
        <TagCondition />
        <Button shape="circle" onClick={removeGroupCondition} className={styles.icon_trash} disabled={isEditDefault}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </div>

      <div className={styles.list_conditions}>
        {orConditions.map((_, conditionIndex) => {

          const key = `or_condition_${index}_${conditionIndex}`;
          const isLastItem = index === orConditions.length - 1;
          return (
            <SimpleCondition
              key={key}
              groupIndex={index}
              index={conditionIndex}
              isLastItem={isLastItem}
            />
          );

        })}
      </div>

      <Button className={styles.btn_add_condition} type="dashed" onClick={() => addOrCondition()} disabled={isEditDefault}>
        {t('views.dynamic_alarms_create_edit.buttons.add_condition')}
      </Button>
    </SpecialCard>
  );

}

GroupCondition.propTypes = {
  index: PropTypes.number.isRequired,
};

export default GroupCondition;
